wbApp.filter('wbFlag', ['$translate', function ($translate) {
    return function (input) {
        switch (input) {
            case 0:
                return $translate.instant('TXT_FLAG_RED');
            case 1:
                return $translate.instant('TXT_FLAG_ORANGE');
            case 2:
                return $translate.instant('TXT_FLAG_YELLOW');
            case 3:
                return $translate.instant('TXT_FLAG_GREEN');
            case 4:
                return $translate.instant('TXT_FLAG_BLUE');
            case 5:
                return $translate.instant('TXT_FLAG_PURPLE');
            case 6:
                return $translate.instant('TXT_FLAG_GRAY');
            default:
                return '';
        }
    };
}]);